<div class="cart-summary h-100 d-flex flex-column flex-md-row justify-content-around d-xxl-block">
  <div class="px-4 points-summary">
    <div class="indigo-text bold-text pt-10">{{ 'Points Summary' | translate }}</div>
    <div class="mt-4 d-flex justify-content-between">
      <div class="text-18 bold-text pe-5">{{ 'Available points to redeem' | translate }}</div>
      <div class="text-18">{{ (accountSummary$ | async)?.availableBalance | number }}</div>
    </div>
  </div>

  <div class="product-summary">
    <div class="indigo-text bold-text mt-10 px-4">{{ 'Shopping cart' | translate }}</div>
    <div class="d-flex align-items-center table-header mt-3 px-4">
      <div class="w-50 text-18 bold-text">
        {{ 'Product' | translate }}
      </div>
      <div class="w-25 text-18 bold-text">
        {{ 'Qty' | translate }}
      </div>
      <div class="text-18 bold-text">
        {{ 'Price' | translate }}
      </div>
      <div class="flex-fill d-flex justify-content-end">
        <div></div>
      </div>
    </div>

    <ng-container *ngFor="let item of cart?.products">
      <div class="d-flex px-4 pt-3">
        <div class="text-18 w-50">
          {{ item.name }}
        </div>
        <div class="text-18 w-25 ps-3">
          {{ item.quantity }}
        </div>
        <div class="text-18 ps-1">
          {{ item.points | number }}
        </div>
        <div class="flex-fill d-flex justify-content-end">
          <div>
            <button class="p-0 btn close-button" (click)="removeItem(item)">
              <fa-icon [icon]="['fal', 'xmark']" size="lg"></fa-icon>
            </button>
          </div>
        </div>
      </div>

      <div>
        <hr />
      </div>
    </ng-container>

    <div class="px-4 mt-3 d-flex align-items-center justify-content-between" *ngIf="cart && cart.products.length > 0">
      <div class="text-18 bold-text">{{ cart.products.length }} {{ 'items' | translate }}</div>
      <div class="text-18 bold-text">{{ 'Subtotal' | translate }}: {{ cartTotal | number }}</div>
    </div>

    <div class="w-100 px-4 mt-4 mb-5">
      <div class="d-flex justify-content-end justify-content-xxl-center text-18">
        <button
          class="mt-2 w-75 btn btn-primary py-2 cart-button"
          [routerLink]="'/rewards-catalogue/cart'"
          [disabled]="checkoutDisabled"
        >
          {{ 'View cart' | translate }}
        </button>
      </div>
      <a
        class="d-flex justify-content-end justify-content-xxl-start mt-3 p-0 btn btn-link text-decoration-none text-18 clear-button"
        type="button"
        (click)="clearCart()"
      >
        {{ 'Clear cart' | translate }}
      </a>
    </div>
  </div>
</div>
